import React, { useState } from 'react';
import { X, Edit, Database, Calendar, Code, Eye } from 'lucide-react';
import { Model } from '../../types';
import ModelSchemaPreview from '../agents/ModelSchemaPreview';

interface ModelDetailsModalProps {
  model: Model;
  allModels: Model[];
  onClose: () => void;
  onEdit: () => void;
}

const ModelDetailsModal: React.FC<ModelDetailsModalProps> = ({
  model,
  onClose,
  onEdit,
  allModels
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-cap-dark rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
          <h2>{model.class_name}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 dark:text-gray-400 transition-colors">
            <X className="w-6 h-6" />
          </button>
        </div>
        <ModelSchemaPreview model={model} allModels={allModels} />
      </div>
    </div>
  );
};

export default ModelDetailsModal; 